/** @format */
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { getGenreLabel, splitLeadValue } from '../../helpers';
import { DEFAULT_TEST_ID } from './config/constants';
import { KitLeadCardProps } from './config/types';
import { styles } from './kit-lead-card.styles';

export * from './config/constants';
export type { KitLeadCardProps } from './config/types';

const StyledKitLeadCard = styled.div`
    ${styles}
`;

/**
 * The dark anchor of the grid, and a preview of the three themes the cards
 * beside it go into. The value is split into digits and unit by
 * `splitLeadValue`, so a percentage renders with a smaller `%` beside the
 * figure; a value with no unit, like "Nearly all", renders whole.
 */
export const KitLeadCard: FunctionComponent<KitLeadCardProps> = ({
    lead,
    genres,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    ...otherProps
}) => {
    const { t } = useTranslation();
    const { digits, unit } = splitLeadValue(lead.value);

    return (
        <StyledKitLeadCard data-testid={dataTestId} {...otherProps}>
            <span className="kit-lead-card-eyebrow">
                {t('Kit intelligence')}
            </span>
            <span
                className="kit-lead-card-value"
                data-testid={`${dataTestId}__value`}
            >
                <span className="kit-lead-card-digits">{digits}</span>
                {/* eslint-disable-next-line react/jsx-no-leaked-render -- Legacy code: do not use as an example. */}
                {unit && <span className="kit-lead-card-unit">{unit}</span>}
            </span>
            <span className="kit-lead-card-label">{lead.label}</span>
            <p className="kit-lead-card-copy">
                {t(
                    'What photographers buy together tells a bigger story. The cameras, lenses and accessories MPB customers choose at the same time give us a glimpse into how they’re building their kit — and what they might be getting ready to capture.'
                )}
            </p>
            <ul className="kit-lead-card-genres">
                {genres.map((genre) => (
                    <li key={genre} className="kit-lead-card-genre">
                        {getGenreLabel(t, genre)}
                    </li>
                ))}
            </ul>
        </StyledKitLeadCard>
    );
};
